import React from 'react'
import { connect } from 'react-redux'
import { setOpened, getClaimDetail, fetchClients, fetchClient, fetchClientContract, navigateToConnexClaim, fetchClientOptionsDict } from 'state/actions'
import styles from './claimsZoom.scss'
import Uploader from '../uploader'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import KeyValue from '../KeyValue'
import { formatDate, findContractIdByContractNumber, generateClientDicts } from 'lib/helpers'
import EmailButton from '../emailSender/emailButton'
import nesProp from 'nested-property'
import c from 'state/constants'
import MifidButton from '../DSDocuments/mifidButton'
import ClaimWizardButton from '../ClaimsWizard/ClaimWizardButton'

import i18n from 'lib/i18n'
const _ = i18n('claimsZoom')

@connect(state => ({
    claimNumber: state.app.opened,
    isPhone: state.responsive.isPhone,
    EmailTemplateRelations: state.app.security.EmailTemplateRelations,
    clientAccess: state.app.security.actions,
    claimDetail: nesProp.get(state, "client.claimDetail"),
    clientData: nesProp.get(state, "clients.data"),
    clientDataExt: nesProp.get(state, "clients.clientData"),
    appLanguage: state.app.lang,
    clientOptionsDict: state.client.clientOptionsDict,
    contracts: state.contracts,
}))
export default class ClaimsZoom extends React.Component {
    static propTypes = {
        dispatch: React.PropTypes.func.isRequired,
        errors: React.PropTypes.string,
        data: React.PropTypes.object.isRequired,
        clientOptionsDict: React.PropTypes.object,
        isPhone: React.PropTypes.bool,
    }

    /**
     * Constructor: initialize state etc.
     * @param {*} props
     */
    constructor(props) {
        super(props)
        let { clientOptionsDict, appLanguage } = props

        this.state = { 
            clientOptionsDict,
            initializationCompleted: false, 
            claimDetailLoaded: false, 
            clientLoaded: false, 
            contractDetailsLoaded: false, 
            brokerNumber: null, 
            extendedClientOptionsDict: generateClientDicts(clientOptionsDict, appLanguage),
        }
    }

    /**
     * Triggered before update the module.
     * @param {object} nextProps
     * @param {object} nextState
     */
    componentWillUpdate(nextProps, nextState) {
        if (nextState.claimDetailLoaded && nextState.clientLoaded && !nextState.initializationCompleted) {
            this.setState({ initializationCompleted: true })
        }
        let claimContractNumber = nesProp.get(nextProps, "claim.claimMain.contractNumber")
        let contracts = nesProp.get(nextProps, "contracts")
        let contractId = findContractIdByContractNumber(contracts, claimContractNumber)

        // when we have the step when related api calls are finished and got the results
        if (nextProps.contracts && nextProps.data && nextProps.contracts[contractId] && !nextProps.contracts[contractId].companyCancelMail) {
            if (contractId) {
                // get client contract, and the reducer insert the contractManagerMail in to the store
                dispatch(fetchClientContract(contractId))
            }
        }
    }

    componentDidMount() {
        const { dispatch, clientOptionsDict } = this.props;
        try {
            this.fetchData()

            if (!clientOptionsDict || Object.keys(clientOptionsDict).length === 0) {
                dispatch(fetchClientOptionsDict())
                    .then((dictionary) => {
                        this.setClientOptionsDict(dictionary);
                    })
                    .catch((err) => console.error("Error fetching client options dictionary:", err));
            } else {
                if (!this.state.clientOptionsDict) {
                    this.setClientOptionsDict(clientOptionsDict);
                }
            }
        } catch (err) {
            console.error("CDMount fetchData Err ", err)
        }
    }

    /**
     * Fetching clientContracts and clientClaims data from server and set the current brokerNumber
     */
    async fetchData() {
        const { dispatch, data } = this.props
        let { claimDetailLoaded, clientLoaded, contractDetailsLoaded } = this.state
        const claimId = nesProp.get(data, "main.claimId")
        const clientNumber = nesProp.get(data, "main.clientNumber")
        const brokerNumber = nesProp.get(data, "main.brokerNumber"); 

        // +++ CLAIM LOADING IF EXISTS +++
        if (claimId && !claimDetailLoaded) {
            try {
                await dispatch(getClaimDetail(claimId))
            } catch (err) {
                console.error("getClaimDetail ERR ", err)
            }
        }

        // set to true anyway, because, based on it depends the rendering, and must happen even if not
        // necessary to laod it
        claimDetailLoaded = true
        // --- END of loading calim details


        // +++ LOAD CLIENT DATA +++
        let clientId

        if (clientNumber && !clientLoaded) {
            // just return the result no forward to the client profile.
            let justReturn = true
            let fetchClientsResult

            try {
                fetchClientsResult = await dispatch(fetchClients({ clientNumber }, justReturn))
            } catch (err) {
                console.error("fetchClients err", err)
            }

            clientLoaded = fetchClientsResult ? true : false
            clientId = nesProp.get(fetchClientsResult, "0.clientId")
        }


        let claimContractNumber
        let contractId

        // +++ LOAD MORE CLIENT DATA +++
        if (clientId) {
            try {
                await dispatch(fetchClient(clientId))
            } catch (err) {
                console.error("fetchClient err", err)
            }

            // take values direct from this props, not destructure it elsewhere, because the store renew references inbetween
            claimContractNumber = nesProp.get(this.props, "data.main.contractNumber")
            let contracts = nesProp.get(this.props, "contracts")
            contractId = findContractIdByContractNumber(contracts, claimContractNumber) // sync func call
        }
        // --- END of load more client data ---


        // +++ LOAD contract details +++
        if (contractId && !contractDetailsLoaded) {
            try {
                await dispatch(fetchClientContract(contractId))
            } catch (err) {
                console.error("fetchClientContract err", err)
            }

            contractDetailsLoaded = true
        }

        if (brokerNumber) {
            this.setState({ brokerNumber });
    
        } else {
            console.warn("Broker number is undefined");
        }
        // END of load contract details


        // single set state at the endto avoid uneccesarry rerenders
        this.setState({
            claimDetailLoaded,
            clientLoaded,
            contractDetailsLoaded,
            brokerNumber
        })
    }

    /**
     * This function return with values for email sender, collected from this module
     * depending on the current data structure.
     */
    collectVariableValues() {
        const { dispatch, claimNumber, data, claimDetail, clientData, clientDataExt, contracts } = this.props
        let clientId = nesProp.get(clientData, "0.clientId")
        let clientDataById = nesProp.get(clientDataExt, clientId + ".main")

        // digging out the contract related documents
        let claim = data
        let claimContractNumber = nesProp.get(claim, "main.contractNumber")
        let contractId = findContractIdByContractNumber(contracts, claimContractNumber)
        let mainContract = contracts[contractId]

        const contract = nesProp.get(contracts, contractId)
        const contractDocuments = nesProp.get(contract, "documents")
        const contractDocumentsId = contractId

        let emails = nesProp.get(clientDataExt, clientId + '.detail.emails')
        let clientName = nesProp.get(data, "main.clientName")

        if (emails && emails.length) {
            emails = emails.map((item) => ({
                referenceId: clientId,
                label: clientName,
                value: item.email,
                default: (item.default == "true" || item.default == true) ? true : false
            }))

            emails = emails.sort((item, item2) => {
                if (item.default && !item2.default) { return -1 }
                if (!item.default && item2.default) { return 1 }
                if ((item.default && item2.default) || (!item.default && !item2.default)) { return 0 }
            }) || []
        }
        return {
            contractNumber: data.main.contractNumber,
            claimsNumber: claimNumber,
            clientName: clientName,
            clientEmails: emails,

            clientDocuments: nesProp.get(clientDataExt, clientId + ".clientDocuments"),
            clientDocumentsType: 'client',
            clientDocumentsId: clientId,

            // new v6 mode
            claimDocuments: data.documents,
            claimDocumentsType: "claim",
            claimDocumentsId: data.main.claimId,
            companyCancelMail: nesProp.get(mainContract, 'companyCancelMail'),

            contractDocuments: contractDocuments,
            contractDocumentsType: "contract",
            contractDocumentsId: contractDocumentsId,

            clientId: false,
            contractId: false,
            claimId: data.main.claimId,
            company: data.details.insuranceCompany,

            brokerNumber: nesProp.get(data, "main.brokerNumber"),
            claim: data,
            claimDetail,
            clientNumber: nesProp.get(clientDataById, "clientNumber"),
            clientData: clientDataById,

        }
    }

    /**
     * This function render the data for the qualification column in the claims result table.
     * @param {object} main - thi is the claims record main property, what contains the qualification values
     */
    formatQualification(qualification, subQualification) {
        return (
            <span>
                <span>
                    {qualification}
                </span>
                {subQualification &&
                    <span>
                        ,<br />
                        {subQualification}
                    </span>
                }
            </span>)
    }

    /**
     * Get client id if we have clientData
     * @param {*} clientNumber
     * @returns clientId
     */
    getClientId(clientNumber) {
        const { clientData } = this.props

        let clientId
        if (clientData && Array.isArray(clientData)) {
            clientData.map(oneClient => {
                clientId = oneClient.clientNumber === clientNumber ? oneClient.clientId : clientId
            })
        } else {
            console.warn("clientData is not an array as expected, maybe is not loaded yet: ", clientData)
        }
        return clientId
    }


    zoomTo(claimNumber) {
        const { dispatch } = this.props
        return dispatch(navigateToConnexClaim(c.CLAIMS, claimNumber))
    }

    render() {
        const { claimNumber, data, dispatch, isPhone, clientAccess, claimDetail } = this.props

        if (!data) {
            return <div>...</div>
        }

        const connex = data.connex || []
        const { initializationCompleted, brokerNumber, extendedClientOptionsDict } = this.state
        const createmail = clientAccess &&
            clientAccess.filter((item) => (item.actionName == "createmail" && item.actionAllowed == "true")).length > 0
        const moduleKeyToSet = nesProp.get(this.props, "EmailTemplateRelations.EmailTemplateModules.claims.value") || false
        const canCreateMifid = clientAccess &&
            clientAccess.filter((item) => (item.actionName == "createmifid" && item.actionAllowed == "true")).length > 0
        const claimId = nesProp.get(data, 'main.claimId')
        const clientId = this.getClientId(nesProp.get(data, 'main.clientNumber'))
        const contractId = this.collectVariableValues().contractDocumentsId;

        const columns = [
            [
                { label: _('clientName'), value: data.main.clientName },
                { label: _('insuranceCompany'), value: data.details.insuranceCompany },
                { label: _('claimDate'), value: formatDate(data.main.claimDate) },
                { label: _('state'), value: data.main.state },
                { label: _('contractNumber'), value: data.main.contractNumber },
                { label: _('riskDescription'), value: data.details.riskDescription },
                { label: _('claimRefBroker'), value: data.main.claimRefBroker}
            ],
            [
                { label: _('brokerNumber'), value: data.main.brokerNumber },
                { label: _('claimsManager'), value: data.main.claimsManagerName },
                { label: _('creationDate'), value: formatDate(data.main.creationDate) },
                { label: _('qualification'), value: this.formatQualification(data.main.qualification, data.main.subQualification) },
                { label: _('branche'), value: data.details.branche }
            ],
        ]

        let involvedPartiesLabels = []
        let missingDocumentsLabels = []
        const claimStatusAndQualification = {}

        if (claimDetail) {
            claimStatusAndQualification.claimStatus = claimDetail.claimStatus
            claimStatusAndQualification.qualificationNumber = claimDetail.qualificationNumber
            claimStatusAndQualification.subQualificationNumber = claimDetail.subQualificationNumber

            involvedPartiesLabels = claimDetail.missingInfo.involvedParties.map(value => {
                const involvedTexts = extendedClientOptionsDict.involvedParties.find(option => option.value === value)
                return involvedTexts ? involvedTexts.label : ''
            })

            for (const oneDoc of claimDetail.missingInfo.documents) {
                if (claimDetail.Documents && claimDetail.Documents.length > 0) {
                    const missingDocType = claimDetail.Documents.find(doc => doc.docType === oneDoc.docType);
                    if (missingDocType) {
                        if (missingDocType.alternativeDocTypes && missingDocType.alternativeDocTypes.length > 0) {
                            const selectedAlternative = missingDocType.alternativeDocTypes.find(altDoc => +altDoc.altDocCount > 0);
                            if (selectedAlternative) {
                                missingDocType.alternativeDocTypes
                                    .filter(altDoc => +altDoc.altDocCount === 0 && altDoc.alternativeNr === selectedAlternative.alternativeNr)
                                    .forEach(altDoc => {
                                        const newLabel = extendedClientOptionsDict.documentTypeOptions.find(option => option.value === altDoc.altDocType);
                                        if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
                                            missingDocumentsLabels.push(newLabel);
                                        }
                                    });
                            } else {
                                const newLabel = extendedClientOptionsDict.documentTypeOptions.find(option => option.value === oneDoc.docType);
                                if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
                                    missingDocumentsLabels.push(newLabel);
                                }
                            }
                        } else if (missingDocType.docCount && +missingDocType.docCount <= 0) {
                            const newLabel = extendedClientOptionsDict.documentTypeOptions.find(option => option.value === oneDoc.docType);
                            if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
                                missingDocumentsLabels.push(newLabel);
                            }
                        }
                    }
                }
            }
        }

        return (
            <div className={styles.claimsZoom}>
                <div className={styles.mainTitleDiv}>
                    <div className={styles.mainTitleContainer}>
                        <h2 className={styles.mainTitle}>{_('claims')}</h2>
                    </div>
                    {!isPhone &&
                        <div className={styles.moduleControls}>
                            <div onClick={() => dispatch(setOpened())} id="backToList" className={styles.greyButton}>{_('backToList')}</div>
                            {createmail && initializationCompleted &&
                                <EmailButton
                                    moduleKeyToSet={moduleKeyToSet}
                                    moduleOptions={this.collectVariableValues()}
                                />
                            }
                            {canCreateMifid && clientId &&
                                <div className={styles.DSWizardButtonWrapper}>
                                    <MifidButton
                                        moduleKeyToSet={c.DS_MODULE_CLIENT_CLAIMS}
                                        subModuleKeyToSet={c.DS_MODULE_CLIENT_CLAIMS}
                                        clientId={clientId}
                                        claimId={claimId}
                                        claimNumber={claimNumber}
                                        callBackOnClose={() => { }}
                                        moduleOptions={this.collectVariableValues()}
                                    />
                                </div>
                            }
                            {claimDetail && claimDetail.claimStatus === '8' && <div>
                                <div className={styles.wizardButtonCorrection} >
                                    <ClaimWizardButton
                                        claimNumber={claimNumber}
                                        contractId={contractId}
                                        clientId={clientId}
                                        brokerNumber={brokerNumber}
                                        onCloseMethod={() => this.props.dispatch(getClaimDetail(claimId))}
                                        onGoing={true}
                                    />
                                </div>
                            </div>}
                        </div>
                    }
                </div>
                <div className={styles.agentClaimsZoom}>
                    <div className={styles.moduleSection}>
                        <div className={styles.moduleSectionHeading}>
                            <h2 className={styles.subTitle}>{_('claimNumber')} <span>{claimNumber}</span></h2>
                        </div>
                        <KeyValue array={columns} divider />
                    </div>
                    {(claimDetail && involvedPartiesLabels.length > 0 || missingDocumentsLabels.length > 0) && <div className={styles.moduleSection}>
                        <div className={styles.moduleSectionHeading}>
                            <h2 className={styles.subTitle}>
                                {_('missingInfo')}
                            </h2>
                        </div>
                        <div className={styles.missingInfo}>
                            {involvedPartiesLabels.length > 0 && <div className={styles.missingInfoColumn}>
                                <span className={styles.missingInfoTitle}>{_('missingInvolvedParties')}:</span>
                                <div className={styles.missingInfoEnum}>
                                    {involvedPartiesLabels.map((label, index) => (
                                        <span key={index} className={styles.missingInfoRow}>{label}</span>
                                    ))}
                                </div>
                            </div>}
                            {missingDocumentsLabels.length > 0 && <div className={styles.missingInfoColumn}>
                                <span className={styles.missingInfoTitle}>{_('missingDocuments')}:</span>
                                <div className={styles.missingInfoEnum}>
                                    {missingDocumentsLabels.map((label, index) => (
                                        <span key={index} className={styles.missingInfoRow}>{label.label}</span>
                                    ))}
                                </div>
                            </div>}
                        </div>
                    </div>}

                    <div className={styles.moduleSection}>
                        <div className={styles.moduleSectionHeading}>
                            <h2 className={styles.conexTitle}>
                                {_('connex')}
                            </h2>
                        </div>
                        <Table
                            className={styles.table}
                            itemsPerPage={20}
                        >
                            <Thead>
                                <Th column="claimNumber">
                                    <strong>{_('claimNumber')}</strong>
                                </Th>
                                <Th column="nameClient">
                                    <strong>{_('nameClient')}</strong>
                                </Th>
                                <Th column="contractNumber">
                                    <strong>{_('contractNumber')}</strong>
                                </Th>
                                <Th column="companyName">
                                    <strong>{_('companyName')}</strong>
                                </Th>
                                <Th column="qualification">
                                    <strong>{_('qualification')}</strong>
                                </Th>
                                <Th column="state">
                                    <strong>{_('state')}</strong>
                                </Th>
                            </Thead>
                            {connex.map((item, key) =>
                                <Tr
                                    className="clickable centered"
                                    onClick={() => this.zoomTo(item.claimNumber)} key={key}
                                >
                                    <Td column="claimNumber">{item.claimNumber}</Td>
                                    <Td column="nameClient">{item.clientName}</Td>
                                    <Td column="contractNumber">{item.contractNumber}</Td>
                                    <Td column="companyName">{item.companyName}</Td>
                                    <Td column="qualification">{item.qualification}</Td>
                                    <Td column="state">{item.state}</Td>
                                </Tr>
                            )
                            }
                        </Table>
                    </div>

                    <Uploader type="claim" documents={data.documents} id={data.main.claimId} claimStatusAndQualification={claimStatusAndQualification} />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/claims/claimsZoom.jsx